import { Col, Row } from "react-bootstrap";
import { IoIosArrowBack } from "react-icons/io";

import { ShadowContainer } from "../CustomComponents/index";
import styles from "./styles/AccountLayout.module.scss";

interface AccountLayoutProps {
  hasBackButton?: boolean;
  handleBackButton?: () => void;
  children: React.ReactNode;
}

const AccountLayout = ({
  hasBackButton = false,
  handleBackButton = () => { },
  children, }: AccountLayoutProps
) => {
  return (
    <div
      className={styles.AccountLayout}
    // style={{ backgroundImage: `url(/images/account_bg.png)` }}
    >
      <ShadowContainer />
      <div className={styles.sectionContainer}>
        <Row className={styles.row}>
          <Col md={7} className={styles.formContainer}>
            <img
              src="/images/full-logo.png"
              alt="Logo"
              width={"150px"}
              className={`${styles.image} ${styles.logo}`}
            />
            <br></br>
            <div className={styles.form}>
              {hasBackButton && (
                <div
                  className={styles?.backButtonContainer || ""}
                  onClick={handleBackButton}
                  role="button"
                  aria-label="Go Back"
                >
                  <IoIosArrowBack />
                </div>
              )}

              {children}
            </div>
          </Col>
          {
            // <Col
            // md={6}
            // className={`${styles.mediaContainer}`}
            // >
            // <img src='/images/logo_assets.png' alt='Logo Assets' className={styles.image} />
            // <img src='/images/logo.png' alt="Logo" className={`${styles.image} ${styles.logo}`} />
            // </Col>
          }
        </Row>
      </div>
    </div>
  );
}


export default AccountLayout;
